import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { CameraInterface } from '../../core';

import styles from './Cameras.module.scss';

export type CamerasProps = {
  cameras: CameraInterface[];
  onSelect: (camera: CameraInterface) => void;
};

const Cameras: React.FC<CamerasProps> = React.memo((props) => {
  const [t] = useTranslation();
  return !!props.cameras.length ? (
    <div className={styles.ff_cameras} data-testid='cameras'>
      {props.cameras.map((camera) => (
        <div
          className={classnames(styles.ff_cameras__camera, {
            [styles.ff_cameras__camera__selected]: camera.selected,
          })}
          onClick={() => props.onSelect(camera)}
          key={camera.id}
          data-testid='camera'
        >
          <img src={camera.imageUrl || `imgs/camera.png`} alt={t('CAMERA_ALT')} />
        </div>
      ))}
    </div>
  ) : null;
});

export default Cameras;
